
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import {Component, Vue} from "vue-property-decorator"

@Component({
  components: {
    RouteBreadCrumb
  }
})
export default class SlidingBannerIndex extends Vue {

}
